(ns frontend.view.modals.new-kpi-report.view
  (:require
   [clojure.string :as string]
   [common.entity :as entity]
   [common.localization :as loc]
   [common.util :as cu :refer [flip]]
   [frontend.state.current-session :as session]
   [frontend.view.modals.components.input :as input]
   [frontend.view.modals.new-kpi-report.events :as events]
   [reagent.core :as r]
   [ui.components.modal.view :as modal]
   [ui.components.toggle.view :as toggle]))

(defonce modal-key :new-kpi-report-modal)

;;
;; Views
;;

(defn view
  [{:keys [shown? close-modal! props state topmost?]}]
  (let [edit-state (r/cursor state [:edit])
        entity-atom (r/cursor state [:entity-atom])
        state-atom (r/cursor state [:state-atom])
        {:keys [category member company cycle]} props]
    (events/reset-state! edit-state category member)
    (fn [{:keys [shown? close-modal! props state class-name topmost?]}]
      (let [{:keys [category member company cycle]} props
            edit-report @edit-state
            {:keys [kpi-cycle/target-month kpi-cycle/target-year]} cycle
            cycle-name (:kpi-cycle/name cycle)
            category-id (:db/id category)
            category-name (:kpi-category/name category)
            company-id (:db/id company)
            their-contact (->> member
                               :kpi-member/account
                               (get @session/entities))
            company-roles (->> @session/all-roles
                               (cu/only-entity :role/target company-id)
                               (remove :common/disabled?)
                               (map :role/subject)
                               set)
            role-disabled? (not (and their-contact
                                     (not (:common/disabled? their-contact))
                                     (contains? company-roles (:db/id their-contact))))
            cycles (->> @session/all-kpi-cycles
                        (cu/only-entity :kpi-cycle/kpi-category category-id)
                        (remove :common/disabled?))
            ;;use latest cycle to get latest values for members
            ;; (report with matching [:kpi-report/cycle :kpi-report/company]
            ;;  => take :common/owner and :kpi-report/contact-account (:kpi-report/contact-person not needed?))
            latest-cycle (->> cycles
                              (sort-by (juxt :kpi-cycle/target-year :kpi-report/target-month))
                              last)
            report-exists? (->> @session/all-kpi-reports
                                (remove :common/disabled?)
                                (cu/only-entity :kpi-report/company (:db/id company))
                                (cu/only-entity :kpi-report/cycle (:db/id cycle))
                                empty?
                                not)
            email-title (:kpi-report/email-title edit-report)
            email-copy (:kpi-report/email-copy edit-report)
            notify? (:notify? edit-report)
            button-disabled? (or report-exists?
                                 (string/blank? email-title)
                                 (string/blank? email-copy))]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :close-button? true}
         (loc/tr :new-report-modal/title [cycle-name])
         [:<>
          (if role-disabled?
            [:div.new-kpi-report-modal
             (loc/tr :new-report-modal/no-role-info)]
            [:div.new-kpi-report-modal
             [:div.report-modal-info (loc/tr :new-report-modal/info [category-name])]

             [:div.d-flex.align-items-center
              [:div.pr-3 (loc/tr :new-report-modal/notify-contact)]
              [toggle/toggle
               {:checked?  (boolean notify?)
                :on-change (fn [_]
                             (swap! edit-state update-in [:notify?] not))}]]

             (when notify?
               [:div.report-modal-email-container
                [:div.report-modal-heading
                 (loc/tr :new-report-modal/from)]
                [:div.report-modal-line.report-modal-category-name
                 (loc/tr :zapflow-reporting-email)]

                [:div.report-modal-heading.pt-2
                 (loc/tr :new-report-modal/to)]
                [:div.report-modal-line
                 [:span.their-contact-name (entity/display-string their-contact :long)]]

                ;;TODO email-title & -copy kpi-cycle's or kpi-report's attribute? (latest cycle's values?)
                [input/simple-text-field
                 {:type        :text
                  :entity      edit-report
                  :attribute   :kpi-report/email-title
                  :label       (loc/tr :kpi-report/email-title)
                  ;;:placeholder (loc/tr :kpi-wizard/cycle-name-placeholder)
                  :entity-atom entity-atom
                  :validate!   (fn [attribute val]
                                 (swap! edit-state assoc attribute val)
                                 (when (empty? val)
                                   (loc/tr :error-field-not-clearable [(loc/tr attribute)])))
                  :on-save!    (fn [attribute new-value on-success! on-error!]
                                 ;;make sure local state is cleared when no changes:
                                 (when (and (= new-value (get edit-report attribute))
                                            (fn? on-success!))
                                   (on-success!))
                                 (swap! edit-state assoc attribute new-value)
                                 (on-success!))}]

                [input/simple-text-field
                 {:type        :textarea
                  :entity      edit-report
                  :attribute   :kpi-report/email-copy
                  :label       (loc/tr :kpi-report/email-copy)
                  :entity-atom entity-atom
                  :validate!   (fn [attribute val]
                                 (swap! edit-state assoc attribute val)
                                 (when (empty? val)
                                   (loc/tr :error-field-not-clearable [(loc/tr attribute)])))
                  :on-save!    (fn [attribute new-value on-success! on-error!]
                                 ;;make sure local state is cleared when no changes:
                                 (when (and (= new-value (get edit-report attribute))
                                            (fn? on-success!))
                                   (on-success!))
                                 (swap! edit-state assoc attribute new-value)
                                 (on-success!))}]])])]
         [:<>
          [modal/left-cancel-only close-modal! nil]
          [modal/right-single-button
           nil
           (and (boolean button-disabled?)
                notify?)
           #(events/create-report! state cycle company close-modal!)
           (cond role-disabled?
                 (loc/tr :create-report)
                 (not notify?)
                 (loc/tr :create-without-notifying)
                 :else
                 (loc/tr :create-and-send-email))
           nil]]]))))
